import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import vSelect from 'vue-select'
import VueVega from 'vue-vega'
import './assets/scss/theme.scss'
import router from './router'
import App from './App.vue'
import store from './store'
import { gerDate, moneyFormat } from './utils/format'

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueVega)
Vue.component('v-select', vSelect)
Vue.config.productionTip = false

Vue.filter('ger_date', gerDate)
Vue.filter('money', moneyFormat)

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
